import script from "./SvTimeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvTimeline.vue?vue&type=script&setup=true&lang=ts"

import "./SvTimeline.vue?vue&type=style&index=0&id=1f28c1ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.7_typescript@4.9.5__webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f28c1ae"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../node_modules/.pnpm/@quasar+app-webpack@3.11.3__19fadae530b491e33818dbf1a8400ef1/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTimeline,QTimelineEntry});
